import { Box, Collapse } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomFormSelect from 'components/inputs/CustomFormSelect/CustomFormSelect';

import { filterContentReportSectionList, filterContentReportStatusList, filterContentReportTargetList } from 'common/constants';
import { ContentReportsFiltersDto } from 'types/dto/ContentReportsFiltersDto';

interface Props {
  open: boolean;
  initialValues: ContentReportsFiltersDto;
  loading: boolean;
  onApply: (filters: ContentReportsFiltersDto) => void;
  onReset: () => void;
}

export default function ContentReportsFilters({
  open,
  initialValues,
  loading,
  onApply,
  onReset,
}: Props) {
  const methods = useForm<ContentReportsFiltersDto>({
    defaultValues: initialValues,
  });

  const { handleSubmit, reset } = methods;

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box
        sx={{
          px: 2,
          py: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <FormProvider {...methods}>
          <Box
            component="form"
            onSubmit={handleSubmit(onApply)}
            display="grid"
            gridTemplateColumns={{ xs: '1fr', md: 'repeat(4, 1fr)' }}
            gap={2}
            flex={1}
          >

            {/* Status */}
            <CustomFormSelect
              name="status"
              floatingLabel='Status'
              options={filterContentReportStatusList}
            />

            {/* Type */}
            <CustomFormSelect
              name="targetType"
              floatingLabel='Type'
              options={filterContentReportTargetList}
            />

            {/* Section */}
            <CustomFormSelect
              name="section"
              floatingLabel='Section'
              options={filterContentReportSectionList}
            />

            {/* Actions */}
            <Box
              display="flex"
              gap={1}
              alignItems="flex-end"
              justifyContent="flex-end"
              sx={{
                alignSelf: 'end',
              }}
            >
              <CustomButton
                fullWidth
                text="Reset"
                variant="outlined"
                height={40}
                disabled={loading}
                onClick={() => {
                  reset();
                  onReset();
                }}
              />
              <CustomButton
                fullWidth
                text="Search"
                type="submit"
                height={40}
                loading={loading}
              />
            </Box>
          </Box>
        </FormProvider>
      </Box>
    </Collapse>
  );
}
